/**
 * Parses a string representation of a number into a numeric value or returns a default value if the parsing fails.
 * @param number The string representation of the number to parse.
 * @param defaultValue The default value to return if the parsing fails. Optional.
 * @returns The parsed numeric value or the default value if the parsing fails.
 */

export const parseNumber = (number?: string, defaultValue?: number): Maybe<number> =>
  number ? Number(number) : defaultValue;

/**
 * Returns the maximum value between a given number and a maximum value.
 * @param number The number to evaluate.
 * @param max The maximum value to compare against.
 * @returns The maximum value between the number and the maximum value.
 */

export const maxNumber = (number: number, max: number): number => (number > max ? max : number);

/**
 * Formats a number by using the specified locale and adds thousand separators and decimal places if necessary.
 * @param number The number to format.
 * @param locale The locale to use for formatting.
 * @returns The formatted number as a string.
 */

// export function formatNumber(number: number, locale: string, customDecimal: number = 0): string {
//   // Check if the number has decimal places
//   const hasDecimalPlaces: boolean = number % 1 !== 0;

//   // const defaultDecimal: number = 2;

//   // Define formatting options based on decimal places
//   const options: Intl.NumberFormatOptions = {
//     minimumFractionDigits: hasDecimalPlaces ? 2 : 0,
//     maximumFractionDigits: hasDecimalPlaces ? 2 : 0,
//   };

//   // Format the number using the appropriate locale and options
//   const formattedNumber: string = number.toLocaleString(locale, options);

//   return formattedNumber;
// }

export function formatNumber(number: number, locale: string, customDecimal: number = 0): string {
  // Multipliez le nombre par 100 pour déplacer les décimales à deux positions à droite
  const multipliedNumber = number * 100;

  // Utilisez Math.floor pour tronquer au lieu d'arrondir
  const truncatedNumber = Math.floor(multipliedNumber);

  // Divisez à nouveau par 100 pour ramener les décimales à leur position d'origine
  const result = truncatedNumber / 100;

  // Formattez le résultat selon vos besoins
  const formattedResult = result.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formattedResult;
}
